import React from 'react';
import styles from 'components/dialog/index.module.scss';
import DialogLayout from 'components/dialog-layout';

const Dialog = ({
  isShow = false,
  withClose,
  image,
  title,
  message = '',
  button,
  onConfirm,
  cancelButton,
  onDismiss,
}) => {
  const messageContent = () => {
    if (typeof message !== 'string') return message;
    return <div dangerouslySetInnerHTML={{ __html: message.replace(/(?:\r\n|\r|\n)/g, '<br>') }} />;
  };
  return (
    <DialogLayout isShow={isShow} withClose={withClose} onDismiss={onDismiss}>
      <div className={styles.dialog}>
        {image && (
          <div className={styles.image}>
            <img src={image} alt="dialog-img" />
          </div>
        )}
        <div className={styles.title}>{title}</div>
        <div className={styles.message}>{messageContent()}</div>
        <div className={styles.button} onClick={onConfirm}>
          {button}
        </div>
        {cancelButton && (
          <div className={`${styles.button} ${styles.cancel}`} onClick={onDismiss}>
            {cancelButton}
          </div>
        )}
      </div>
    </DialogLayout>
  );
};

export default Dialog;
